import PropTypes from 'prop-types'
import React from 'react'

import {
  GRID_VARIANT_COLLAPSED,
  GRID_VARIANT_DEFAULT,
  GRID_VARIANT_SMALL,
  GRID_VARIANT_VERTICAL_0,
  GRID_VARIANT_VERTICAL_16,
  GRID_VARIANT_VERTICAL_24,
  GRID_VARIANT_VERTICAL_32,
  GRID_VARIANT_VERTICAL_8,
  GRID_VARIANT_VERTICAL_BIG,
  GRID_VARIANT_VERTICAL_DEFAULT
} from './Grid.constants'
import { StyledGridCell, StyledGridContainer } from './Grid.styles'

export const GridCell = ({
  className,
  children,
  span,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <StyledGridCell
      className={className}
      span={span}
      data-mu-test={dataAttributeTest}
    >
      {children}
    </StyledGridCell>
  )
}

export const Grid = ({
  className,
  children,
  cols,
  'data-mu-test': dataAttributeTest,
  variant,
  variantVertical
}) => {
  return (
    <StyledGridContainer
      className={className}
      cols={cols}
      variant={variant}
      variantVertical={variantVertical}
      data-mu-test={dataAttributeTest}
    >
      {children}
    </StyledGridContainer>
  )
}

GridCell.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  span: PropTypes.number,
  'data-mu-test': PropTypes.string
}

Grid.defaultProps = {
  variantVertical: GRID_VARIANT_VERTICAL_DEFAULT
}

Grid.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  cols: PropTypes.number,
  'data-mu-test': PropTypes.string,
  variant: PropTypes.oneOf([
    GRID_VARIANT_DEFAULT,
    GRID_VARIANT_SMALL,
    GRID_VARIANT_COLLAPSED
  ]),
  variantVertical: PropTypes.oneOf([
    GRID_VARIANT_VERTICAL_DEFAULT,
    GRID_VARIANT_VERTICAL_BIG,
    GRID_VARIANT_VERTICAL_0,
    GRID_VARIANT_VERTICAL_8,
    GRID_VARIANT_VERTICAL_16,
    GRID_VARIANT_VERTICAL_24,
    GRID_VARIANT_VERTICAL_32
  ])
}
